import script from "./XForm.vue?vue&type=script&lang=tsx"
export * from "./XForm.vue?vue&type=script&lang=tsx"

import "./XForm.vue?vue&type=style&index=0&id=cabc2ee4&scoped=true&lang=less"
script.__scopeId = "data-v-cabc2ee4"

export default script